import { render } from "./TestPL.vue?vue&type=template&id=e3817680"
import script from "./TestPL.vue?vue&type=script&lang=js"
export * from "./TestPL.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__